import { isBefore } from 'date-fns'

export function campaignStatusReadable(status: CampaignStatusType, startDate: Date) {
  if (status !== 'ACTIVE') {
    return status
  }

  if (isBefore(new Date(), startDate)) {
    return 'SCHEDULED'
  }

  return status
}
